import { render, staticRenderFns } from "./epics_list_section.vue?vue&type=template&id=5fdea477"
import script from "./epics_list_section.vue?vue&type=script&lang=js"
export * from "./epics_list_section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports